<template>
    <CollapsibleWidget v-if="options.length > 0">
        <template #name>Master Template Families</template>

        <template #controls></template>

        <CheckboxGroup v-model="selectedValues" class="editable-group__values" :vertical="true">
            <Checkbox v-for="option in options" :key="option.value" :label="option.value">
                {{ option.label }}
            </Checkbox>
        </CheckboxGroup>
    </CollapsibleWidget>
</template>

<script lang="ts">
type FamilyFilter = {
    children: string[];
    parentId: string;
};
import { defineComponent, type PropType } from "vue";

import { deepClone } from "@/utils";

import CollapsibleWidget from "@/components/Campaign/widgets/CollapsibleWidget.vue";

import {
    FilterType,
    MasterTemplateLibraryAction,
    MasterTemplateLibraryGetters
} from "@/store/modules/masterTemplateLibrary";

export default defineComponent({
    name: "MasterTemplateFamilyFilter",
    components: { CollapsibleWidget },

    props: {
        campaignMasterTemplateIds: {
            type: Array as PropType<string[]>,
            default() {
                return [];
            }
        }
    },

    emits: [],

    computed: {
        filterValues() {
            return this.$store.state.masterTemplateLibrary.filters.filter(filter => filter.type === FilterType.Family);
        },

        masterTemplates() {
            return this.$store.state.masterTemplateLibrary.masterTemplates;
        },

        options() {
            const families: Record<string, FamilyFilter> =
                this.$store.getters[MasterTemplateLibraryGetters.templateFamiliesByParentId];

            return Object.values(families)
                .filter(({ parentId, children }) => parentId && children.length)
                .map(({ parentId }) => ({ value: parentId, label: this.masterTemplates[parentId].name }));
        },

        selectedValues: {
            get() {
                if (this.filterValues.length) {
                    const filterValuesCopy = deepClone(this.filterValues);

                    return filterValuesCopy.pop()?.values;
                }

                return [];
            },
            set(newValue: string[]) {
                this.$store.dispatch(MasterTemplateLibraryAction.UpdateFamilyFilter, {
                    values: newValue
                });
            }
        }
    },

    beforeUnmount() {
        this.selectedValues = [];
    }
});
</script>

<style lang="scss">
.editable-group {
    &__add {
        width: 100%;
    }

    &__values {
        width: 100%;
    }

    .show-form {
        &--showing {
            display: none;
        }
    }
}
</style>
